"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
export default function AboutUsOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="за-нас-преглед" className="relative bg-background text-foreground py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1504672/img/about_us_texture_pattern.png)] bg-no-repeat bg-cover bg-center opacity-5 pointer-events-none"></div>
      <div className="container relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {}
          <div ref={textRef} className={`space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <h2 className="font-display text-[32px] md:text-[40px] leading-tight text-foreground">
              Нашата история и ценности
            </h2>
            <div className="space-y-4 text-muted-foreground">
              <p className="text-[16px] leading-relaxed">Миш‑Маш /интерпред/ е създаден с мисията да донесе свежест и разнообразие в света на бързото хранене. Всеки ден обновяваме менюто си, за да предложим на нашите гости най‑добрите ястия, приготвени с внимание и грижа. Работим от понеделник до петък (с изключение на резервации за събития, направени за събота и неделя).</p>
              <p className="text-[16px] leading-relaxed">
                Ние вярваме, че бързото хранене не означава компромис с качеството. Затова залагаме на свежи и висококачествени съставки, автентични домашни рецепти и модерна атмосфера, която кани всеки да се почувства добре дошъл.
              </p>
              <p className="text-[16px] leading-relaxed">
                Нашият екип работи с ентусиазъм и отдаденост, за да осигури на
                всеки клиент незабравимо изживяване – от първата поръчка до
                последната хапка.
              </p>
            </div>
            <Card className="card bg-[#F0F0F0] p-6 border-none">
              <div className="space-y-3">
                <h3 className="font-display text-[22px] font-semibold text-foreground">
                  Нашите основни ценности
                </h3>
                <ul className="space-y-2 text-muted-foreground">
                  <li className="flex items-start gap-3" data-index={0}>
                    <span className="text-primary-active text-[20px] leading-none mt-0.5">
                      •
                    </span>
                    <span className="text-[15px]">Прясно и на място</span>
                  </li>
                  <li className="flex items-start gap-3" data-index={1}>
                    <span className="text-primary-active text-[20px] leading-none mt-0.5">
                      •
                    </span>
                    <span className="text-[15px]">Истинско качество без надценка</span>
                  </li>
                  <li className="flex items-start gap-3" data-index={2}>
                    <span className="text-primary-active text-[20px] leading-none mt-0.5">
                      •
                    </span>
                    <span className="text-[15px]">Собственикът - в кухнята</span>
                  </li>
                  <li className="flex items-start gap-3" data-index={3}>
                    <span className="text-primary-active text-[20px] leading-none mt-0.5">
                      •
                    </span>
                    <span className="text-[15px]">Бързо, но с грижа</span>
                  </li>
                </ul>
              </div>
            </Card>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`}>
            <div className="card overflow-hidden bg-[#F0F0F0] border-none hover-lift">
              <img src="https://first-ladybird.10web.cloud/wp-content/uploads/2026/02/IMG-91fc20efaab3289aa9c45c2745b7bbca-V.webp" alt="Екипът на Миш-Маш /интерпред/ в кухнята" className="w-full h-auto object-cover rounded-lg" />
            </div>
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-primary/10 rounded-full blur-3xl pointer-events-none"></div>
            <div className="absolute -top-6 -left-6 w-24 h-24 bg-accent/10 rounded-full blur-2xl pointer-events-none"></div>
          </div>
        </div>
      </div>
    </section>;
}